<template lang="pug">
    div( @click="$emit('click', data.id)")
        | {{data.name}}
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
